<script setup lang="ts">
import { onMounted } from 'vue';
import { useUrlHelper } from '@/shared/infrastructure/composition/useUrlHelper';
import BaseSection from '@/application/shared/infrastructure/components/BaseSection.vue';
import { CarrierList, useRoute } from '@hfc/ui-core';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';

const route = useRoute();

const { getRouteNameByAppType } = useUrlHelper();

const props = defineProps<{
  applicationType: APPLICATION_TYPES;
  carrier: CarrierList;
  message?: string;
  routeName?: string;
  routeParam?: string;
  linkText?: string;
}>();

const getRouteParams = (): Record<string, string> => {
  if (!props.routeParam) {
    return {};
  }

  return { [props.routeParam as string]: route.params[props.routeParam as string] as string };
};

onMounted(() => {
  localStorage.removeItem(`${props.applicationType}SaveAndExit`);
});

</script>
<template>
  <div class="flex flex-1 mt-4 lg:mt-24 mb-4 items-start justify-center">
    <BaseSection class="w-full lg:w-2/3">
      <div class="space-y-4">
        <carrier-logo class="flex items-center justify-center py-6 max-w-[200px] mx-auto" :coverage-type="applicationType" :carrier-id="carrier" vertical="true" no-link="true" />
        <h1>Thank you for choosing us!</h1>
        <div v-if="!props.message" class="flex flex-col space-y-2">
          <p>Your information has been saved, and we’ve sent you an email with directions on how to resume your application.</p>
          <p>You must finish your saved application at least 1 day before your selected effective date. Otherwise, you will be required to start a new quote.</p>
        </div>
        <div v-else v-html="props.message"></div>
        <br>
        <router-link :to="{name: !props.routeName ? getRouteNameByAppType(props.applicationType, 'Application') : props.routeName, query: { saveAndExit: 'true' }, params: getRouteParams()}">
          {{ props.linkText ?? 'Resume Application now' }}
        </router-link>
      </div>
    </BaseSection>
  </div>
</template>
